"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_4g__plus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "4g-plus-hi"), /*#__PURE__*/React.createElement("g", {
    id: "90d1236b-01e5-47a8-ba81-9fddc771c79a",
    "data-name": "4g-plus-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6d5f3768-fa12-4fd0-b698-54aca35a768d",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "242c2bae-13a6-4ed0-8d9c-1bcb3739412b",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d934c952-c905-4573-aa5b-187da2fb4e74",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6c850cc1-db4a-47fe-8d5c-5ac0cd8bc1cf",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a45372a8-2426-4e65-8a96-d7c23efb969f",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a7a7160-7beb-4d86-b51d-a34e750e9464",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "119db76f-307a-408a-9ad0-b633e1577047",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1342e28d-5e79-4693-9724-4f8e5dbc895f",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "790806ee-3ead-45a8-bc40-0ad54eb902ee",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8c4a7a7-a554-443d-9498-90ef7b476cf3",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dc43eada-7ef0-4d90-a773-274b977271a6",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25292b3b-c0e8-4c40-b2dc-0d69aceb7550",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bf738a96-83de-40dd-b9d1-f8743258128d",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0196d418-acc9-4042-9bb1-b2d6905ac0d4",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6862cb77-ac1d-4f4e-8f6c-e0b97c201107",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "370dbbcf-d6ee-49e4-be13-1d2ca1a52b11",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "78657969-845f-4dae-9537-d7c96c27dfe1",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5c6ec7a-dffb-4b69-ad2d-ef4ba72f6e23",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b590678-14ac-4291-b189-ddd9b5de518b",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8e0d343-0fb2-4771-ae6e-0c72d22affa4",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "615b1bca-57cb-4691-9b9a-05e3b53197fe",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a4dc31be-1a64-4f3d-a11b-c544c5061edd",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "27c096b9-d793-4891-be48-05920d4e2460",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d20844e1-5aa9-4e10-9fb5-16da0eccb7b0",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "68145c0c-94d6-4e86-a974-75f74eef47a7",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46c55ec7-0a1a-4a88-9f29-c9049067f640",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ae7bae26-5a58-472d-8a93-58be1dc008fd",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.25a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.25Z",
    transform: "translate(0 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.89,126.5V114H29.3v-9.5l28.7-42h9.89V103h6.24v11H67.89V126.5ZM42.36,103H55.89V82.44Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5,127.84A29.21,29.21,0,0,1,97,125.64a24.38,24.38,0,0,1-9-6.48,30.14,30.14,0,0,1-5.81-10.42,43.9,43.9,0,0,1-2.06-14A45.12,45.12,0,0,1,82.39,79.8a30.7,30.7,0,0,1,6-10.46,23.69,23.69,0,0,1,8.59-6.19,26.36,26.36,0,0,1,10.22-2q8.26,0,13.54,3.12a21.05,21.05,0,0,1,8,8L120.21,80a15.89,15.89,0,0,0-3.07-3.89,13.66,13.66,0,0,0-4.51-2.69,15.23,15.23,0,0,0-5.38-1,11.87,11.87,0,0,0-8,3.07,17,17,0,0,0-5.09,8.3,38.47,38.47,0,0,0-1.54,10.9,29.21,29.21,0,0,0,2.59,12.72q2.59,5.42,6.43,7.2a17.74,17.74,0,0,0,7.49,1.78,35.62,35.62,0,0,0,6.19-.43,16.91,16.91,0,0,0,2.74-.62V103.84h-10v-11h21.5v30.82a27.76,27.76,0,0,1-7.87,2.88A56.34,56.34,0,0,1,108.5,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.66,110.88V99H135.74V92.4h10.92V80.34h6.24V92.4h10.92V99H152.9v11.88Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }))))))))))))))))))))))))))))));
}

var _default = ic_4g__plus;
exports.default = _default;